export default function Dashboard() {
  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h1 className="dashboard-title">لوحة التحكم الإدارية</h1>
        <p className="dashboard-subtitle">مرحباً بك في نظام إدارة المحتوى</p>
      </header>

      <div className="dashboard-stats">
        <div className="stat-card">
          <div className="stat-icon">📊</div>
          <div className="stat-content">
            <h3 className="stat-value">1,234</h3>
            <p className="stat-label">المستخدمون النشطون</p>
          </div>
          <div className="stat-trend">+12%</div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">📈</div>
          <div className="stat-content">
            <h3 className="stat-value">567</h3>
            <p className="stat-label">الجلسات اليومية</p>
          </div>
          <div className="stat-trend">+8%</div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">💰</div>
          <div className="stat-content">
            <h3 className="stat-value">$4,890</h3>
            <p className="stat-label">الإيرادات الشهرية</p>
          </div>
          <div className="stat-trend">+23%</div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">✅</div>
          <div className="stat-content">
            <h3 className="stat-value">89%</h3>
            <p className="stat-label">معدل الرضا</p>
          </div>
          <div className="stat-trend">+5%</div>
        </div>
      </div>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h2 className="card-title">المحتوى الحديث</h2>
          <div className="content-list">
            <div className="content-item">
              <span className="content-type">مقال</span>
              <span className="content-title">مقدمة في الذكاء الاصطناعي</span>
              <span className="content-date">منذ ساعتين</span>
            </div>
            <div className="content-item">
              <span className="content-type">فيديو</span>
              <span className="content-title">تطوير تطبيقات الويب الحديثة</span>
              <span className="content-date">منذ 5 ساعات</span>
            </div>
            <div className="content-item">
              <span className="content-type">صورة</span>
              <span className="content-title">معرض الصور الجديد</span>
              <span className="content-date">منذ يوم</span>
            </div>
          </div>
        </div>

        <div className="dashboard-card">
          <h2 className="card-title">المهام السريعة</h2>
          <div className="quick-actions">
            <button className="action-btn">
              <span className="action-icon">➕</span>
              <span>إضافة مستخدم جديد</span>
            </button>
            <button className="action-btn">
              <span className="action-icon">📝</span>
              <span>كتابة مقال جديد</span>
            </button>
            <button className="action-btn">
              <span className="action-icon">⚙️</span>
              <span>تعديل الإعدادات</span>
            </button>
            <button className="action-btn">
              <span className="action-icon">📊</span>
              <span>عرض التقارير</span>
            </button>
          </div>
        </div>
      </div>

      <div className="recent-activity">
        <h2 className="section-title">النشاطات الأخيرة</h2>
        <div className="activity-list">
          <div className="activity-item">
            <div className="activity-icon">👤</div>
            <div className="activity-content">
              <p>قام أحمد بتسجيل الدخول إلى النظام</p>
              <span className="activity-time">منذ 10 دقائق</span>
            </div>
          </div>
          <div className="activity-item">
            <div className="activity-icon">📝</div>
            <div className="activity-content">
              <p>تم نشر مقال جديد "مستقبل التكنولوجيا"</p>
              <span className="activity-time">منذ ساعة</span>
            </div>
          </div>
          <div className="activity-item">
            <div className="activity-icon">🔄</div>
            <div className="activity-content">
              <p>تم تحديث إعدادات النظام</p>
              <span className="activity-time">منذ 3 ساعات</span>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .dashboard-container {
          padding: 2rem;
          max-width: 1400px;
          margin: 0 auto;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          direction: rtl;
        }

        .dashboard-header {
          text-align: center;
          margin-bottom: 3rem;
          padding-bottom: 2rem;
          border-bottom: 1px solid #e2e8f0;
        }

        .dashboard-title {
          color: #2d3748;
          font-size: 2.5rem;
          margin-bottom: 0.5rem;
          background: linear-gradient(135deg, #4299e1, #667eea);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .dashboard-subtitle {
          color: #718096;
          font-size: 1.1rem;
        }

        .dashboard-stats {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 1.5rem;
          margin-bottom: 3rem;
        }

        .stat-card {
          background: white;
          border-radius: 16px;
          padding: 1.5rem;
          display: flex;
          align-items: center;
          gap: 1rem;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          border: 1px solid #e2e8f0;
          transition: all 0.3s ease;
        }

        .stat-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          border-color: #4299e1;
        }

        .stat-icon {
          font-size: 2.5rem;
          background: linear-gradient(135deg, #4299e1, #38b2ac);
          width: 70px;
          height: 70px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
        }

        .stat-content {
          flex: 1;
        }

        .stat-value {
          color: #2d3748;
          font-size: 1.8rem;
          font-weight: 700;
          margin: 0;
        }

        .stat-label {
          color: #718096;
          font-size: 0.9rem;
          margin: 0.25rem 0 0 0;
        }

        .stat-trend {
          color: #48bb78;
          font-weight: 600;
          font-size: 0.9rem;
          background: #f0fff4;
          padding: 0.25rem 0.75rem;
          border-radius: 20px;
        }

        .dashboard-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
          gap: 2rem;
          margin-bottom: 3rem;
        }

        .dashboard-card {
          background: white;
          border-radius: 16px;
          padding: 1.5rem;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          border: 1px solid #e2e8f0;
        }

        .card-title {
          color: #2d3748;
          font-size: 1.3rem;
          margin-bottom: 1.5rem;
          padding-bottom: 1rem;
          border-bottom: 2px solid #4299e1;
        }

        .content-list {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .content-item {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1rem;
          background: #f7fafc;
          border-radius: 8px;
          transition: all 0.3s ease;
        }

        .content-item:hover {
          background: #edf2f7;
          transform: translateX(-5px);
        }

        .content-type {
          background: #4299e1;
          color: white;
          padding: 0.25rem 0.75rem;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 600;
        }

        .content-title {
          flex: 1;
          color: #2d3748;
          font-weight: 500;
        }

        .content-date {
          color: #718096;
          font-size: 0.85rem;
        }

        .quick-actions {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          gap: 1rem;
        }

        .action-btn {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.5rem;
          padding: 1.5rem 1rem;
          background: white;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          color: #2d3748;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .action-btn:hover {
          border-color: #4299e1;
          background: #ebf8ff;
          transform: translateY(-3px);
        }

        .action-icon {
          font-size: 2rem;
        }

        .recent-activity {
          background: white;
          border-radius: 16px;
          padding: 1.5rem;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          border: 1px solid #e2e8f0;
        }

        .section-title {
          color: #2d3748;
          font-size: 1.3rem;
          margin-bottom: 1.5rem;
        }

        .activity-list {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .activity-item {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1rem;
          background: #f7fafc;
          border-radius: 12px;
          transition: all 0.3s ease;
        }

        .activity-item:hover {
          background: #edf2f7;
        }

        .activity-icon {
          width: 50px;
          height: 50px;
          background: linear-gradient(135deg, #667eea, #764ba2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 1.5rem;
        }

        .activity-content {
          flex: 1;
        }

        .activity-content p {
          color: #2d3748;
          margin: 0 0 0.25rem 0;
          font-weight: 500;
        }

        .activity-time {
          color: #718096;
          font-size: 0.85rem;
        }

        @media (max-width: 768px) {
          .dashboard-container {
            padding: 1rem;
          }
          
          .dashboard-grid {
            grid-template-columns: 1fr;
          }
          
          .dashboard-stats {
            grid-template-columns: repeat(2, 1fr);
          }
          
          .quick-actions {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 480px) {
          .dashboard-stats {
            grid-template-columns: 1fr;
          }
          
          .content-item {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.5rem;
          }
        }
      `}</style>
    </div>
  );
}